import {ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot} from '@angular/router';
import {Injectable} from '@angular/core';
import {Observable} from 'rxjs/Observable';
import {UserService} from './user.service';

@Injectable()
export class TestGuard implements CanActivate {
  constructor(private userService: UserService,
              private router: Router) {
  }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> | Promise<boolean> | boolean {
    const user = this.userService.getLocal();
    if (!user) {
      return true;
    }
    if (user.testing) {
      this.router.navigate(['/dashboard/testing']);
    }
    return !user.testing;
  }
}



// WEBPACK FOOTER //
// C:/work/internal-frontend/src/app/services/test-guard.service.ts